import { render, staticRenderFns } from "./addOthers.vue?vue&type=template&id=53c3992a&scoped=true"
import script from "./addOthers.vue?vue&type=script&lang=js"
export * from "./addOthers.vue?vue&type=script&lang=js"
import style0 from "./addOthers.vue?vue&type=style&index=0&id=53c3992a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c3992a",
  null
  
)

export default component.exports